<template>
    <div>
        <div class="controls">
            <button @click="rotateImage" class="btn btn-light"><i class="icon-rotate-cw mr-2"></i>Rotera 90°</button>
        </div>
        <div class="image-container">
            <img :src="imageSrc" :style="{ transform: `rotate(${value}deg)` }" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0,
        },
        imageSrc: {
            type: String,
            required: true,
        },
    },
    watch: {
        value(newVal) {
            this.rotation = newVal;
        },
    },
    mounted() {
        this.rotation = this.value;
    },
    data() {
        return {
            rotation: 0, // Start with no rotation
        };
    },
    methods: {
        rotateImage() {
            this.rotation = (this.rotation + 90) % 360; // Rotate by 90 degrees, reset after 360
            if (this.value !== this.rotation) {
                this.$emit('input', this.rotation);
            }
        },
    },
};
</script>

<style scoped>
.image-container {
    width: 100%;
    overflow: hidden;
    position: relative;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-container:before{
    content: "";
    display: block;
    padding-top: 100%;
}

img {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    transition: transform 0.3s ease-in-out;
}

.controls {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
}
</style>
